import { Component, OnInit } from '@angular/core';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import { Observable } from 'rxjs';
import { NavController, LoadingController, AlertController } from '@ionic/angular';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-saude-detalhes',
    templateUrl: './saude-detalhes.page.html',
    styleUrls: ['./saude-detalhes.page.scss'],
})
export class SaudeDetalhesPage implements OnInit {

  formularioObj: any;
  authState: boolean = false;
  idAtual: any;
   
  constructor(
    private passaObjetoService: PassaObjetoService,
    public loadingController: LoadingController,
    public http: HttpClient,
    public alertController: AlertController
  ) {
    this.formularioObj = this.passaObjetoService.navParams.form
    this.passaObjetoService.navParams = null
  }

  ngOnInit() {
   
   
  }

  
}
 


